<template>
    <b-form @submit.prevent="submitUnlinkedMember" autocomplete="off">
        <b-container>
            <b-row md="12" class="pb-3">
                <b-col md="6">
                    <!-- Nombre !-->
                    <b-form-group
                        label="<strong>Nombre *</strong>"
                        label-for="name"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <b-form-input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Nombre"
                            autocomplete="off"
                            v-model="unlinkedMember.name"
                            class="w-100"
                            v-validate="'required|min:3'"
                            :state="validateState('name')"
                            aria-describedby="check_name">
                        </b-form-input>
                        <div class="text-danger text-right" id="check_name">
                            <small>{{ errors.first('name') }}</small>
                        </div>
                    </b-form-group>

                    <!-- Apellidos !-->
                    <b-form-group
                        label="<strong>Apellidos *</strong>"
                        label-for="surname"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <b-form-input
                            id="surname"
                            name="surname"
                            type="text"
                            placeholder="Apellidos"
                            autocomplete="off"
                            v-model="unlinkedMember.surname"
                            class="w-100"
                            v-validate="'required|min:3'"
                            :state="validateState('surname')"
                            aria-describedby="check_surname">
                        </b-form-input>
                        <div class="text-danger text-right" id="check_surname">
                            <small>{{ errors.first('surname') }}</small>
                        </div>
                    </b-form-group>

                    <!-- NIF !-->
                    <b-form-group
                        label="<strong>NIF *</strong>"
                        label-for="nif"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <b-form-input
                            id="nif"
                            name="nif"
                            type="text"
                            placeholder="NIF"
                            autocomplete="off"
                            v-model="unlinkedMember.nif"
                            class="w-100"
                            v-validate="'required|nif'"
                            :state="validateState('nif')"
                            aria-describedby="check_nif">
                        </b-form-input>
                        <div class="text-danger text-right" id="check_nif">
                            <small>{{ errors.first('nif') }}</small>
                        </div>
                    </b-form-group>

                    <!-- Sexo !-->
                    <b-form-group
                        label="<strong>Sexo *</strong>"
                        label-for="sex"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <multiselect
                            name="sex"
                            v-model="unlinkedMember.sex"
                            :allow-empty="false"
                            :options="sexes.map(type => type.value)"
                            :custom-label="opt => sexes.find(x => x.value == opt).text"
                            selectLabel="+"
                            deselectLabel="-"
                            placeholder="Seleccione opción"></multiselect>
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <!-- Cumpleaños !-->
                    <b-form-group
                        label="<strong>Fecha de Nacimiento *</strong>"
                        label-for="birthday"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <v-date-picker
                            v-model='unlinkedMember.birthday'
                            class="p-0 form-control date-picker-w-100 date-picker-custom-border"
                            :max-date="maxDate"
                            :required="true">
                        </v-date-picker>
                        <div class="text-danger text-right" id="check_birthday">
                            <small>{{ errors.first('birthday') }}</small>
                        </div>
                    </b-form-group>

                    <!-- Email !-->
                    <b-form-group
                        label="<strong>Email</strong>"
                        label-for="email"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <b-form-input
                            id="email"
                            name="email"
                            type="text"
                            placeholder="Email"
                            autocomplete="off"
                            v-model="unlinkedMember.email"
                            class="w-100"
                            v-validate="'email'"
                            :state="validateState('email')"
                            aria-describedby="check_email">
                        </b-form-input>
                        <div class="text-danger text-right" id="check_email">
                            <small>{{ errors.first('email') }}</small>
                        </div>
                    </b-form-group>

                    <b-form-group
                        label="<strong>Teléfono</strong>"
                        label-for="phone"
                        :horizontal="false"
                        class="w-100 mb-3 text-left">
                        <b-form-input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="Teléfono"
                            autocomplete="off"
                            v-model="unlinkedMember.phone"
                            class="w-100"
                            v-validate="'phone'"
                            :state="validateState('phone')"
                            aria-describedby="check_phone">
                        </b-form-input>
                        <div class="text-danger text-right" id="check_phone">
                            <small>{{ errors.first('phone') }}</small>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mt-4">
                <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                    <div>&nbsp</div>
                    <div>
                        <button
                            type="submit"
                            class="btn btn-brand btn-primary btn-lg">
                            Guardar
                        </button>
                    </div>
                </div>
            </b-row>
        </b-container>
    </b-form>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    import {setupCalendar, DatePicker} from 'v-calendar';
    import 'v-calendar/lib/v-calendar.min.css';
    import {getMemberSexesOptions} from '@/helpers/member-helper';

    export default {
        name: "UnlinkedMemberForm",
        components: {
            'v-date-picker': DatePicker,
            Multiselect
        },
        props: ['initialUnlinkedMember'],
        data: function () {
            return {
                unlinkedMember: {
                    uuid: this.initialUnlinkedMember.uuid,
                    nif: this.initialUnlinkedMember.nif,
                    name: this.initialUnlinkedMember.name,
                    surname: this.initialUnlinkedMember.surname,
                    sex: this.initialUnlinkedMember.sex,
                    birthday: (
                        !!this.initialUnlinkedMember.birthday
                            ? new Date(this.initialUnlinkedMember.birthday)
                            : null
                    ),
                    email: this.initialUnlinkedMember.email,
                    phone: this.initialUnlinkedMember.phone
                },
                maxDate: null
            };
        },
        created() {
            let date = new Date();
            date.setFullYear(date.getFullYear() - 18);
            this.maxDate = date;
        },
        computed: {
            sexes() {
                return getMemberSexesOptions();
            },
        },
        methods: {
            submitUnlinkedMember() {
                this.$emit('submit-query-category', {
                    uuid: this.unlinkedMember.uuid,
                    nif: this.unlinkedMember.nif,
                    name: this.unlinkedMember.name,
                    surname: this.unlinkedMember.surname,
                    sex: this.unlinkedMember.sex,
                    birthday: this.unlinkedMember.birthday,
                    email: this.unlinkedMember.email,
                    phone: this.unlinkedMember.phone
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref);
                } else {
                    return null;
                }
            }
        }
    }
</script>

<style scoped>

</style>